export default {
  name: "uploaded",
  box: 28,
  svg: `<path
  d="M24.9375 8.26602L21.4375 10.2812V6.125C21.4375 5.15977 20.6527 4.375 19.6875 4.375H3.5C2.53477 4.375 1.75 5.15977 1.75 6.125V21.875C1.75 22.8402 2.53477 23.625 3.5 23.625H19.6875C20.6527 23.625 21.4375 22.8402 21.4375 21.875V17.7188L24.9375 19.734C25.5199 20.0703 26.25 19.6492 26.25 18.9793V9.02344C26.25 8.35078 25.5199 7.92969 24.9375 8.26602ZM19.4688 21.6562H3.71875V6.34375H19.4688V21.6562ZM24.2812 17.0898L21.4375 15.4547V12.548L24.2812 10.9102V17.0898ZM5.6875 9.84375H8.75C8.87031 9.84375 8.96875 9.74531 8.96875 9.625V8.3125C8.96875 8.19219 8.87031 8.09375 8.75 8.09375H5.6875C5.56719 8.09375 5.46875 8.19219 5.46875 8.3125V9.625C5.46875 9.74531 5.56719 9.84375 5.6875 9.84375Z"
  fill="black"
/>`,
};
